// Cache for memoization - cleared when items array changes
const pathCache = new Map(); // Stores computed results
let cachedItemsById = null; // Stores the index {id: item}
let lastItemsArray = null; // Tracks if array changed

export function getItemPath(itemId, items, isDebug = false) {
    if (!itemId || !items) {
        return '';
    }

    // Build index once when items array changes (instead of .find() in loop)
    // This converts O(n²) to O(n) performance
    if (items !== lastItemsArray) {
        cachedItemsById = items.reduce((acc, item) => {
            acc[item.id] = item;
            return acc;
        }, {});
        pathCache.clear();
        lastItemsArray = items;
    }

    // Check cache first
    const cacheKey = `${itemId}_${isDebug}`;
    if (pathCache.has(cacheKey)) {
        return pathCache.get(cacheKey);
    }

    // Build path using indexed lookup (O(1) per lookup instead of O(n))
    const path = [];
    let currentItem = cachedItemsById[itemId];

    while (currentItem) {
        const name = isDebug
            ? `${currentItem.name} (ID: ${currentItem.id})`
            : currentItem.name;
        path.unshift(name);
        if (currentItem.parentId) {
            currentItem = cachedItemsById[currentItem.parentId];
        } else {
            currentItem = null;
        }
    }

    const result = path.join(' / ');
    pathCache.set(cacheKey, result);
    return result;
}
